<template>
  <div style="background-color:#ffffff">
    <base-assessment
      :profile="profile"
      :care-plan="carePlan"
      :assessments="assessments"
      :assessments-unanswered="assessmentsUnanswered"
      :path="path"
      :path-root-doc="pathRootDoc"
      :heartbeat="heartBeat"
      :fam="fam"
      @generate-plan="handleGeneratePlan"
    />
    <hr />
    <b-row style="margin-top: 15px;">
      <b-col offset="3">
        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
          <b-button-group>
            <b-button
              style="margin-right: 25px;"
              title="Page Left"
              variant="primary"
              :disabled="cpIdx <= 0"
              @click="handlePageTo(cpIdx - 1)"
            >
              <b-icon icon="chevron-bar-left" aria-hidden="true" />
            </b-button>
            <b-row style="margin-right: 15px;">
              <b-col>
                <b-row class="text-center">
                  <b-col>{{ cpIdx + 1 }} of {{ maxCps }}</b-col>
                </b-row>
                <b-row>
                  <b-col><date-format-toggle :date="createdAt"/></b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-button
              variant="primary"
              :disabled="cpIdx == maxCps - 1"
              @click="handlePageTo(cpIdx + 1)"
            >
              <b-icon icon="chevron-bar-right" aria-hidden="true" />
            </b-button>
          </b-button-group>
          <b-button
            style="margin-left: 25px;"
            variant="primary"
            @click="handleProcessDoc()"
          >
            Process Doc
          </b-button>
          <b-button
            v-if="true"
            @click="handleToggleAssessmentClick"
            variant="primary"
            style="margin-left: 15px;"
            size="sm"
          >
            Assessment Info
          </b-button>
        </b-button-toolbar>
      </b-col>
    </b-row>
    <b-collapse :id="assessmenInfoCollapse" class="mt-2">
      <b-card>
        <pre class="card-text">
          {{ assessmentInfo }}
      </pre
        >
      </b-card>
    </b-collapse>
    <div style="margin-top: 25px;">
      <b-tabs
        :pills="tabs.isPills"
        :small="tabs.isSmall"
        :justified="tabs.isJustified"
        :isFill="tabs.isFill"
        :end="tabs.isEnd"
        :vertical="tabs.isVertical"
        defaultActiveKey="stage"
      >
        <b-tab
          v-for="(aSection, index) in availSections"
          :key="index"
          :title="aSection.title"
        >
          <template #title>
            <h5 style="padding-top: 25px; cursor: pointer">
              <b-icon
                v-if="aSection.icon"
                :icon="aSection.icon"
                aria-hidden="true"
              />
              {{ aSection.title }}
            </h5>
          </template>
          <b-container>
            <component
              :is="aSection.component"
              v-bind="Object.assign({}, { ...propsData, section: aSection })"
              :ref="aSection.componentName"
              @input-answer="handleInputAnswer"
            />
          </b-container>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseAssessment from "./baseAssessment";
import CarePlanBlock from "./carePlanBlock";
import DateFormatToggle from "@/components/common/dateFormatToggle";

export default {
  name: "LivingCarePlan",
  components: {
    BaseAssessment,
    DateFormatToggle
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.resetCarePlan();
  },
  props: {
    profile: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    carePlan: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    assessments: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    assessmentsUnanswered: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    doc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    accountType: {
      type: String,
      default: "provider"
    },
    formPrompt: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    path: {
      type: String,
      required: true,
      default: ""
    },
    pathRootDoc: {
      type: String,
      required: true,
      default: ""
    },
    apps: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    cpIdx: {
      type: Number,
      default: 0
    },
    maxCps: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({}),
    accountTypeForGetter() {
      return this.accountType ? `${this.accountType}/` : "";
    },
    createdAt() {
      return this.doc && this.doc._created_at ? this.doc._created_at : null;
    },
    assessmentInfo() {
      return this.doc && this.doc.assessmentInfo
        ? this.doc.assessmentInfo
        : null;
    },
    availSections() {
      return this.sections.filter(aSection => {
        return !!(aSection.avail && aSection.active);
      });
    },
    propsData() {
      return {
        heartbeat: this.heartBeat,
        fam: this.fam,
        profile: this.profile,
        formprompt: this.formPrompt,
        path: this.path,
        pathrootdoc: this.path,
        session: this.session,
        apps: this.apps,
        doc: this.doc,
        planid: this.carePlanId
      };
    },
    docGenPlan() {
      return this.doc && this.doc.genPlan ? this.doc.genPlan : null;
    }
  },
  methods: {
    handleToggleAssessmentClick() {
      this.$root.$emit("bv::toggle::collapse", this.assessmenInfoCollapse);
    },
    handleGeneratePlan() {
      this.$emit("generate-plan");
    },
    handleInputAnswer(answKV) {
      this.$emit("input-answer", answKV);
    },
    detectJSONKeysWithoutQuotes(jsonObject) {
      const keysWithoutQuotes = [];

      for (const key in jsonObject) {
        if (!/^[a-zA-Z0-9_]+$/.test(key)) {
          keysWithoutQuotes.push(key);
        }
      }

      return keysWithoutQuotes;
    },
    processCurCarePlan() {
      if (this.docGenPlan) {
        //Check to see if data is available for any of our section
        this.sections.forEach(aSection => {
          aSection.info = aSection.id ? this.docGenPlan[aSection.id] : null;
          //Turn tabs on or off
          aSection.active =
            aSection.info && aSection.info.length > 0 ? true : false;
        });
      }
    },
    resetCarePlan() {
      this.availSections.forEach(aSection => {
        aSection.active = false;
      });
    },
    handlePageTo(pageNumber) {
      this.$emit("page-to", pageNumber);
    },
    handleProcessDoc() {
      this.$emit("process-doc");
    }
  },
  watch: {
    doc(newValue, oldValue) {
      if (newValue) {
        this.processCurCarePlan();
      }
    }
  },
  data() {
    return {
      assessmenInfoCollapse: "assessment-info-collapse",
      heartBeat:
        this.carePlan && this.carePlan.plan && this.carePlan.plan.heartbeat
          ? this.carePlan.plan.heartbeat
          : null,
      fam:
        this.carePlan && this.carePlan.plan && this.carePlan.plan.fam
          ? this.carePlan.plan.fam
          : null,
      carePlanId: this.carePlan && this.carePlan.id ? this.carePlan.id : null,
      formprompt: this.formPrompt ? this.formPrompt : null,
      providerId:
        this.profile && this.profile.userId ? this.profile.userId : null,
      cpJSON: {},
      tabs: {
        isPills: false,
        isSmall: true,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: true
      },
      tab: {
        titleLinkAttributes: {
          color: "#5695e0"
        },
        hexColorTabBg: "#777",
        hexColorTabText: "#777",
        hexColorScreen: "#777"
      },
      sections: [
        {
          id: "assessment",
          title: "Assessment",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: true
        },
        {
          id: "assessmentsubjective",
          title: "Assessment Subjective",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: true
        },
        {
          id: "diagnosis",
          title: "Diagnosis",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: true
        },
        {
          id: "goals",
          title: "Goals",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "planning",
          title: "Plan",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "rational",
          title: "Rationale",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "implementation",
          title: "Implementat",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "evaluation",
          title: "Evaluate",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "nutrition",
          title: "Nutrition",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "dailyroutine",
          title: "Daily Routine",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "monitoring",
          title: "Monitoring",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "legal",
          title: "Legal",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "finance",
          title: "Financial",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "medical",
          title: "Medical Management",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "cognition",
          title: "Cognition",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "routine",
          title: "Daily Routine",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "emotional",
          title: "Emotional Support",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        },
        {
          id: "caregiverpolicy",
          title: "Care Team",
          component: CarePlanBlock,
          componentName: "CarePlanBlock",
          info: null,
          avail: true,
          active: false
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>
